var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d-remote-monitoring-tasks',{on:{"on-sip-call":_vm.onSipCallHandler}})
}
var staticRenderFns = []

export { render, staticRenderFns }